import { motion } from "framer-motion";
import { Reveal } from "@/components/Reveal";

export default function Origins() {
  return (
    <div data-testid="origins-page" className="bg-[#F4F1EA] text-[#1A160F]">
      {/* Opening — generous white space, feather on the right */}
      <section className="min-h-screen pt-32 md:pt-40 pb-20">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="max-w-xl lg:pr-8"
          >
            <span className="text-[0.7rem] tracking-[0.28em] uppercase text-[#A9743F]">
              Our Story
            </span>
            <h1 className="mt-8 font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.08] text-[#1A160F]">
              Before there was a platform, there was a calling.
            </h1>
          </motion.div>

          <div className="relative h-[420px] sm:h-[600px] lg:h-[80vh] flex items-center justify-center lg:justify-end">
            <div className="absolute inset-0 bg-gradient-to-l from-transparent via-[#F4F1EA]/40 to-[#F4F1EA] pointer-events-none z-10" />
            <img
              src="/feather.png"
              alt="A monochrome feather — received through humility, relationship and responsibility."
              className="relative h-full w-auto object-contain opacity-90"
            />
          </div>
        </div>
      </section>

      {/* The rest of the story — quiet, spacious */}
      <section className="pb-40">
        <div className="max-w-2xl mx-auto px-6 md:px-12">
          <div className="space-y-10 text-lg md:text-xl leading-relaxed text-[#4A443B] font-light">
            <Reveal>
              <p>
                Long before WisdomKeepers became a vision for community knowledge systems,
                it began as a quiet question.
              </p>
            </Reveal>
            <Reveal delay={0.08}>
              <p className="font-display text-2xl md:text-3xl text-[#1A160F] leading-snug">
                How do we become faithful stewards of what has been entrusted to us?
              </p>
            </Reveal>
            <Reveal delay={0.14}>
              <p>The feather represents that beginning.</p>
            </Reveal>
            <Reveal delay={0.2}>
              <p>
                Not ownership. Not authority. A reminder that wisdom is received through
                humility, relationship and responsibility.
              </p>
            </Reveal>
          </div>
        </div>
      </section>
    </div>
  );
}
